import { createSlice } from "@reduxjs/toolkit/"

let initialState = {
    questionsList : [],
    selectedQuestion:{},
}
const questionsSlice = createSlice({
    name:'questions',
    initialState,
    reducers:{
        setQuestionsList:(state,{payload})=>{
            state.questionsList = payload
        },
        setSelectedQuestion:(state,{payload})=>{
            state.selectedQuestion = payload
        },
    }
})

export const { setQuestionsList,setSelectedQuestion} = questionsSlice.actions
export default questionsSlice.reducer